// Football card game data with rankings and city imagery
export const FOOTBALL_CARDS = [
  { id: 1, name: "Eagles", rank: 1, image: "/images/football/football_1.jpg" },
  { id: 2, name: "Chiefs", rank: 2, image: "/images/football/football_2.jpg" },
  { id: 3, name: "Commanders", rank: 3, image: "/images/football/football_3.jpg" },
  { id: 4, name: "Texans", rank: 4, image: "/images/football/football_4.jpg" },
  { id: 5, name: "Bills", rank: 5, image: "/images/football/football_5.jpg" },
  { id: 6, name: "Lions", rank: 6, image: "/images/football/football_6.jpg" },
  { id: 7, name: "Cowboys", rank: 7, image: "/images/football/football_7.jpg" },
  { id: 8, name: "Vikings", rank: 8, image: "/images/football/football_8.jpg" },
  { id: 9, name: "Packers", rank: 9, image: "/images/football/football_9.jpg" },
  { id: 10, name: "Bears", rank: 10, image: "/images/football/football_10.jpg" },
  { id: 11, name: "Bengals", rank: 11, image: "/images/football/football_11.jpg" },
  { id: 12, name: "49ers", rank: 12, image: "/images/football/football_12.jpg" },
  { id: 13, name: "Steelers", rank: 13, image: "/images/football/football_13.jpg" },
  { id: 14, name: "Ravens", rank: 14, image: "/images/football/football_14.jpg" },
  { id: 15, name: "Broncos", rank: 15, image: "/images/football/football_15.jpg" },
  { id: 16, name: "Titans", rank: 16, image: "/images/football/football_16.jpg" },
  { id: 17, name: "Raiders", rank: 17, image: "/images/football/football_17.jpg" },
  { id: 18, name: "Dolphins", rank: 18, image: "/images/football/football_18.jpg" },
  { id: 19, name: "Jets", rank: 19, image: "/images/football/football_19.jpg" },
  { id: 20, name: "Chargers", rank: 20, image: "/images/football/football_20.jpg" },
  { id: 21, name: "Patriots", rank: 21, image: "/images/football/football_21.jpg" },
  { id: 22, name: "Buccaneers", rank: 22, image: "/images/football/football_22.jpg" },
  { id: 23, name: "Giants", rank: 23, image: "/images/football/football_23.jpg" },
  { id: 24, name: "Seahawks", rank: 24, image: "/images/football/football_24.jpg" },
  { id: 25, name: "Jaguars", rank: 25, image: "/images/football/football_25.jpg" },
  { id: 26, name: "Rams", rank: 26, image: "/images/football/football_26.jpg" },
  { id: 27, name: "Falcons", rank: 27, image: "/images/football/football_27.jpg" },
  { id: 28, name: "Panthers", rank: 28, image: "/images/football/football_28.jpg" },
  { id: 29, name: "Colts", rank: 29, image: "/images/football/football_29.jpg" },
  { id: 30, name: "Cardinals", rank: 30, image: "/images/football/football_30.jpg" }
];
